var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11,12.75 C16.79,12.75 21.5,17.46 21.5,23.25 C21.5,23.664 21.164,24 20.75,24 C20.336,24 20,23.664 20,23.25 C20,18.287 15.963,14.25 11,14.25 C6.037,14.25 2,18.287 2,23.25 C2,23.664 1.664,24 1.25,24 C0.836,24 0.5,23.664 0.5,23.25 C0.5,17.46 5.21,12.75 11,12.75 Z M11,0 C14.308,0 17,2.692 17,6 C17,9.308 14.308,12 11,12 C7.692,12 5,9.308 5,6 C5,2.692 7.692,0 11,0 Z M11,1.5 C8.519,1.5 6.5,3.519 6.5,6 C6.5,8.481 8.519,10.5 11,10.5 C13.481,10.5 15.5,8.481 15.5,6 C15.5,3.519 13.481,1.5 11,1.5 Z","id":"path-1"}));
}

Users.defaultProps = {"viewBox":"0 0 24 24","version":"1.1"};

module.exports = Users;

Users.default = Users;
